import { VpsAlert } from '../../types/Types';
import ActionTypes from '../Action.types';

type State = {
  vpsAlerts: VpsAlert[];
  isLoading: boolean;
  errMessage: string;
};

type Action = {
  type: string;
  payload: any;
};

function VpsAlertReducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionTypes.start:
      return { ...state, isLoading: true };

    case ActionTypes.find:
      return { ...state, isLoading: false, vpsAlerts: action.payload };

    case ActionTypes.create:
      return {
        ...state,
        isLoading: false,
        vpsAlerts: [...state.vpsAlerts, action.payload],
      };

    case ActionTypes.update:
      return {
        ...state,
        isLoading: false,
        vpsAlerts: state.vpsAlerts.map((vps) =>
          vps.id === action.payload.id ? action.payload : vps
        ),
      };

    case ActionTypes.delete:
      return {
        ...state,
        isLoading: false,
        vpsAlerts: state.vpsAlerts.filter((vps) => vps.id !== action.payload),
      };

    case ActionTypes.error:
      return {
        ...state,
        isLoading: false,
        errMessage: action.payload,
      };

    case ActionTypes.clear:
      return { ...state, isLoading: false, errMessage: '' };
    default:
      return { ...state };
  }
}

export default VpsAlertReducer;
